// packages/whiteboard/src/features/smiley/smiley-options.config.ts

import {
  FILL_ACTIONS,
  Z_ORDER_ACTIONS,
  ALIGN_ACTIONS,
  BOARD_COMMAND_ACTIONS,
  type ActionIntent,
  type ActionsMap,
  type OptionsCircleDef,
} from '../../optionsbar/optionsbar-actions.js';
import { composeOptionsCircle } from '../../optionsbar/parts/compose-options-circle.js';
import { SMILEY_ICON_ORDER } from './smiley-icons.config.js';

// Optionskreis aus Einzelteilen (Smiley = 1 + 3 + 8): Standard-Knoepfe +
// Fuellfarben + der 22er Motiv-Picker.
const smileySvg = composeOptionsCircle([1, 3, 8]);

/**
 * Resolves an optionsbar action intent to a SmileyObject property. `fill`
 * recolours the motif's `id="fill"` element; `smiley-icon` picks the motif.
 * Everything else is inert for a smiley.
 */
function resolveSmileyProperty(intent: ActionIntent): string | null {
  switch (intent) {
    case 'fill':
      return 'fill';
    case 'smiley-icon':
      return 'icon';
    default:
      return null;
  }
}

/**
 * The 22 motif buttons: SVG id `icon1`..`icon22` → that motif key. Plain data
 * mapping (no bespoke action logic) — the shared optionsbar element routes the
 * `smiley-icon` intent through `resolveSmileyProperty` → `icon`.
 */
const SMILEY_ICON_ACTIONS: ActionsMap = Object.fromEntries(
  SMILEY_ICON_ORDER.map((key) => [key, { intent: 'smiley-icon', value: key }]),
);

/**
 * Smiley-specific optionsbar definition (parts 1 + 3 + 8). Composed entirely
 * from shared maps plus the motif picker — no bespoke action logic. Wired: the
 * 22 motif buttons, the fill colour of the motif, z-order and board commands.
 */
export const SMILEY_OPTIONS: OptionsCircleDef = {
  svg: smileySvg,
  actions: {
    ...FILL_ACTIONS,
    ...SMILEY_ICON_ACTIONS,
    ...Z_ORDER_ACTIONS,
    ...ALIGN_ACTIONS,
    ...BOARD_COMMAND_ACTIONS,
  },
  resolveProperty: resolveSmileyProperty,
};
